// components/AssessmentHistoryModal.tsx
import React from 'react';
import { InitialAssessmentSummary } from './InitialAssessmentSummary';
import { SeverityLevel } from '../utils/asthmaTypes';
import './AssessmentHistoryModal.scss';

interface AssessmentHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  topOffset?: number;
  data: {
    age: string;
    respiratoryRate: string;
    oxygenSaturation: string;
    oxygenSupport: boolean;
    auscultation: string;
    retractions: string;
    dyspnea: string;
    score: number;
    severityLabel: string | null;
    activeSeverity: SeverityLevel | null;
    initialAssessmentTime: string | null;
  };
}

export const AssessmentHistoryModal: React.FC<AssessmentHistoryModalProps> = ({ isOpen, onClose, topOffset = 0, data }) => {

  if (!isOpen) return null;

  return (
    <div className="asthma-wrapper">
      <div className="history-modal-overlay" onClick={onClose}>
        <div
          className="history-modal-container"
          style={{ top: topOffset }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="desktop-close-btn" onClick={onClose}>✕</button>

          <div className="history-modal-content">
            {/* Removed the title "Initial Metrics" from here because it was inserted into the component in the new design */}

            <InitialAssessmentSummary
              {...data}
              isModal={true} // <--- This is the trigger that activates the new design
            />
          </div>

          <div className="mobile-handle-bar" onClick={onClose} />

        </div>
      </div>
    </div>
  );
};